/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Etafs_To_ReviewInputs */

const en_queue_etafs_to_review = /** @type {(inputs: Queue_Etafs_To_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-TAFs to review`)
};

/**
* | output |
* | --- |
* | "e-TAFs to review" |
*
* @param {Queue_Etafs_To_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_etafs_to_review = /** @type {((inputs?: Queue_Etafs_To_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Etafs_To_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_etafs_to_review(inputs)
});